import { LifecycleListenerInterface } from '../../core/interfaces/lifecycle-listener.interface';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';

@Injectable()
export class SentryLifecycleListener implements LifecycleListenerInterface {
  constructor(private readonly authService: AuthService) {
  }

  async onFirstLoad(): Promise<void> {
    this.authService.user$.pipe(take(1)).subscribe(user => {
      if (!user) {
        return;
      }

      Sentry.setUser(user);
      console.debug('Set Sentry user:', user);
    });
  }
}
